module.exports = __webpack_public_path__ + "img/Lobby_Banner2.134ef477.jpg";